import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Spinner } from 'dibs-elements/exports/Spinner';
import styles from './styles/LocalSpinner.scss';

const LocalSpinner = ({ wrapperClass = '', inline, isSpinnerStatic, fixedHeight }) => {
    const spinnerColorProp = 'black';
    const additionalProps = { [spinnerColorProp]: true };

    return (
        <div
            className={classNames(wrapperClass, {
                [styles.wrapper]: !wrapperClass && !inline,
                [styles.inline]: inline,
                [styles.isStatic]: isSpinnerStatic,
                [styles.fixedHeight]: fixedHeight,
            })}
        >
            <Spinner containerClass={inline ? styles.inlineSpinner : ''} {...additionalProps} />
        </div>
    );
};

LocalSpinner.propTypes = {
    wrapperClass: PropTypes.string,
    inline: PropTypes.bool,
    isSpinnerStatic: PropTypes.bool,
    fixedHeight: PropTypes.bool,
};

export default LocalSpinner;
